import React, { useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import moment from "moment";
import CustomPopup from "./CustomPopup";
import demoAvatar from "src/assets/images/avatars/avatar.png";

const GPSMap = ({ selectedDevice,lat,long }) => {
  useEffect(() => {
    let {
      latitude,
      longitude,
      updateTimestamp,
      speed,
      heading,
      hdop,
      altitude,
      satellites,
    } = selectedDevice.deviceStatus.currentPosition;
    latitude = lat || latitude;
    longitude = long || longitude;

    console.log(latitude, longitude,"lat",lat,"long",long);
    
    const formattedTimestamp =
      moment(updateTimestamp).format("DD/MM/YYYY, H:mm");
    mapboxgl.accessToken =
      "pk.eyJ1Ijoid3NpdC1zYW1pdWwiLCJhIjoiY2xqM3g1b3FoMWtpODNyb2RmM2V1aTJzbCJ9.u870I5zQLy6w3dWBby5siw";

    const popupData = {
      driver: selectedDevice.driver,
      currentPosition: selectedDevice.deviceStatus.currentPosition,
      lastUpdated: formattedTimestamp,
    };

    console.log(popupData);

    const popupContent = ReactDOMServer.renderToString(
      <CustomPopup device={popupData} demoAvatar={demoAvatar} />
    );

    const map = new mapboxgl.Map({
      container: "location_map",
      style: "mapbox://styles/wsit-samiul/clj3xauf9008501micfqm31y8",
      center: [longitude, latitude],
      zoom: 18,
      scrollZoom: false,
    });
    if (latitude && longitude) {
      new mapboxgl.Marker()
        .setLngLat([longitude, latitude])
        .setPopup(new mapboxgl.Popup().setHTML(popupContent))
        .addTo(map);
    }
    // Add zoom controls
    map.addControl(new mapboxgl.NavigationControl(), "top-right");

    return () => map.remove();
  }, []);

  return (
    <div id="location_map" style={{ width: "100%", height: "500px" }}></div>
  );
};

export default GPSMap;
